"use client";
import { jsxs as g, jsx as n, Fragment as X } from "react/jsx-runtime";
import { ArrowSmallLeftIcon as Lt, CheckmarkIcon as Ot, FullScreenOffIcon as At, ExpandIcon as jt, CrossIcon as mt, CrossSmallIcon as ht, ArrowNextIcon as ct, SettingsIcon as Bt, InfoIcon as at, ErrorIcon as Dt, SuccessIcon as Rt, SoundOffIcon as Ft, SoundOnHalfIcon as Xt, SoundOnIcon as Wt } from "@repo/edtech-assets";
import { memo as Yt, forwardRef as ft, useState as O, useEffect as R, useRef as C, useMemo as Ut, Children as gt, isValidElement as bt, cloneElement as vt, useCallback as E, useLayoutEffect as qt, createElement as G, Fragment as Ht } from "react";
import { useIsMobile as wt, useIsScrollable as yt, ScopedPortal as xt, useClickOutside as Zt } from "@repo/edtech-shared";
import { useProgressInteractions as Gt } from "@repo/edtech-video-player-utils";
const Vt = "_icon_wrapper_1r3ws_1", Jt = "_links_1r3ws_8", Qt = "_arrow_icon_1r3ws_22", zt = "_page_text_1r3ws_27", Kt = "_slash_1r3ws_31", U = {
  icon_wrapper: Vt,
  links: Jt,
  arrow_icon: Qt,
  page_text: zt,
  slash: Kt
}, Bo = ({
  text: t = "Назад",
  pageName: e,
  path: r,
  onClick: o
}) => {
  const s = () => {
    if (o) {
      o();
      return;
    }
    r ? window.location.assign(r) : history.back();
  };
  return /* @__PURE__ */ g("div", { className: U.icon_wrapper, children: [
    /* @__PURE__ */ g(
      "button",
      {
        "aria-label": "Вернуться назад",
        className: U.links,
        onClick: s,
        children: [
          /* @__PURE__ */ n(Lt, { className: U.arrow_icon }),
          /* @__PURE__ */ n("span", { children: t })
        ]
      }
    ),
    /* @__PURE__ */ n("span", { className: U.slash, children: "/" }),
    /* @__PURE__ */ n("span", { className: U.page_text, children: e })
  ] });
};
function Nt(t) {
  var e, r, o = "";
  if (typeof t == "string" || typeof t == "number") o += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var s = t.length;
    for (e = 0; e < s; e++) t[e] && (r = Nt(t[e])) && (o && (o += " "), o += r);
  } else for (r in t) t[r] && (o && (o += " "), o += r);
  return o;
}
function d() {
  for (var t, e, r = 0, o = "", s = arguments.length; r < s; r++) (t = arguments[r]) && (e = Nt(t)) && (o && (o += " "), o += e);
  return o;
}
var kt = /* @__PURE__ */ ((t) => (t.Primary = "primary", t.Outline = "outline", t.Ghost = "ghost", t))(kt || {}), Ct = /* @__PURE__ */ ((t) => (t.Big = "b", t.Medium = "m", t.Small = "s", t))(Ct || {});
const te = "_button_1p3a4_1", ee = "_disabled_1p3a4_20", ne = "_loading_1p3a4_23", oe = "_primary_1p3a4_30", re = "_outline_1p3a4_47", se = "_ghost_1p3a4_65", ce = "_s_1p3a4_79", ae = "_m_1p3a4_83", le = "_b_1p3a4_1", V = {
  button: te,
  disabled: ee,
  loading: ne,
  primary: oe,
  outline: re,
  ghost: se,
  s: ce,
  m: ae,
  b: le
}, ie = Yt(ft(({
  children: t,
  variant: e = kt.Primary,
  size: r = Ct.Small,
  type: o = "button",
  disabled: s,
  className: c,
  ...a
}, u) => /* @__PURE__ */ n(
  "button",
  {
    ref: u,
    className: d(
      V.button,
      V[e],
      V[r],
      s && V.disabled,
      c
    ),
    disabled: s,
    type: o,
    ...a,
    children: t
  }
)));
ie.displayName = "Button";
const _e = "_checkbox_1r09g_1", de = "_checkmark_1r09g_8", ue = "_checked_1r09g_21", pe = "_text_1r09g_25", me = "_hidden_1r09g_30", F = {
  checkbox: _e,
  checkmark: de,
  checked: ue,
  text: pe,
  hidden: me
}, Do = ({
  label: t,
  checked: e,
  name: r,
  onChange: o,
  classNames: s,
  iconClassNames: c
}) => /* @__PURE__ */ g("label", { className: d(F.checkbox, s), children: [
  /* @__PURE__ */ n(
    "input",
    {
      "aria-label": typeof t == "string" ? t : "",
      checked: e,
      className: F.hidden,
      name: r,
      type: "checkbox",
      onChange: o
    }
  ),
  /* @__PURE__ */ n("div", { className: d(F.checkmark, e && F.checked), children: e && /* @__PURE__ */ n(
    Ot,
    {
      className: d(
        F.checkmarkIcon,
        c && c
      )
    }
  ) }),
  /* @__PURE__ */ n("div", { className: F.text, children: t })
] }), he = "_circular_progress_1ex3t_1", fe = {
  circular_progress: he
}, ge = 12, K = 2 * Math.PI * ge, Ro = ({ progress: t }) => {
  const e = K - t / 100 * K;
  return /* @__PURE__ */ n(
    "svg",
    {
      className: fe.circular_progress,
      fill: "none",
      height: "24",
      viewBox: "0 0 24 24",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ n(
        "path",
        {
          d: `M11.9999 22.2858C6.31929 22.2858 1.71422 17.6807
        1.71422 12.0001C1.71422 6.31943 6.31929 1.71435 11.9999
        1.71436C17.6806 1.71436 22.2856 6.31943 22.2856 12.0001C22.2856 17.6807 17.6806 22.2858 11.9999 22.2858Z`,
          fill: "none",
          stroke: "currentcolor",
          strokeDasharray: K,
          strokeDashoffset: e,
          strokeLinecap: "round",
          strokeWidth: "2"
        }
      )
    }
  );
}, Fo = ({ children: t }) => {
  const [e, r] = O(!1);
  return R(() => {
    r(!0);
  }, []), e ? t : null;
}, be = "_wrap_1n7sa_1", ve = "_text_1n7sa_24", lt = {
  wrap: be,
  text: ve
}, we = () => /* @__PURE__ */ n(
  "svg",
  {
    fill: "currentColor",
    height: "1em",
    stroke: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 512 512",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ n(
      "path",
      {
        d: "M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56m0 64.1 64 63.9 64-63.9M256 224v224.03",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "32"
      }
    )
  }
), Xo = ({
  file: t,
  fileName: e,
  className: r
}) => /* @__PURE__ */ g(
  "a",
  {
    download: !0,
    className: d(lt.wrap, r),
    href: t,
    rel: "noreferrer",
    target: "_blank",
    children: [
      /* @__PURE__ */ n(we, {}),
      /* @__PURE__ */ n("span", { className: lt.text, children: e })
    ]
  }
), ye = ({
  onSwipeDown: t,
  onSwipeMove: e,
  threshold: r = 50,
  maxDistance: o = 150,
  lockedScroll: s = !1
}) => {
  const c = C(null), [a, u] = O(!1), _ = (l) => {
    c.current = {
      x: l.clientX,
      y: l.clientY
    }, u(!0);
  }, p = (l) => {
    if (!c.current || !a) return;
    const i = l.clientY - c.current.y;
    if (i > 0) {
      const b = Math.min(i / o, 1);
      e?.(i, b), l.preventDefault?.();
    }
  }, f = (l) => {
    if (!c.current) return;
    l.clientY - c.current.y > r ? t?.() : e?.(0, 0), c.current = null, u(!1);
  };
  return R(() => {
    if (!s) return;
    const l = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = l;
    };
  }, [s]), {
    onPointerDown: _,
    onPointerMove: p,
    onPointerUp: f,
    isDragging: a
  };
};
var Z = /* @__PURE__ */ ((t) => (t.Popover = "popover", t.Sheet = "sheet", t.Fullscreen = "fullscreen", t))(Z || {}), $t = /* @__PURE__ */ ((t) => (t.Left = "left", t.Center = "center", t))($t || {});
const xe = "_dropdown_container_2pe4x_1", Ne = "_popover_2pe4x_5", ke = "_left_2pe4x_13", Ce = "_center_2pe4x_16", $e = "_sheet_2pe4x_21", Se = "_backdrop_2pe4x_28", Ie = "_drag_2pe4x_33", Me = "_content_2pe4x_37", Pe = "_content_sheet_2pe4x_41", Ee = "_handle_2pe4x_54", Te = "_fullscreen_2pe4x_79", Le = "_content_full_2pe4x_86", M = {
  dropdown_container: xe,
  popover: Ne,
  left: ke,
  center: Ce,
  sheet: $e,
  backdrop: Se,
  drag: Ie,
  content: Me,
  content_sheet: Pe,
  handle: Ee,
  fullscreen: Te,
  content_full: Le
}, Oe = ft(({
  isOpen: t,
  onClose: e,
  children: r,
  className: o,
  style: s,
  variant: c = Z.Popover,
  position: a = $t.Left,
  swipe: u,
  ..._
}, p) => {
  const [f, l] = O({
    y: 0,
    progress: 0
  }), i = wt(768), {
    onPointerDown: b,
    onPointerMove: v,
    onPointerUp: y,
    isDragging: $
  } = ye({
    onSwipeDown: () => e?.(),
    onSwipeMove: (A, W) => l({
      y: A,
      progress: W
    }),
    threshold: u?.threshold ?? 80,
    maxDistance: u?.maxDistance ?? 150,
    lockedScroll: t && i
  });
  if (R(() => {
    t || l({
      y: 0,
      progress: 0
    });
  }, [t]), !t) return null;
  const m = c === Z.Sheet, N = c === Z.Fullscreen, w = c === Z.Popover, P = m ? {
    transform: `translateY(${f.y}px)`
  } : {}, I = m ? {
    opacity: Math.max(0.4, 1 - f.progress * 0.6)
  } : {};
  return /* @__PURE__ */ g(
    "div",
    {
      ref: p,
      className: d(
        M.dropdown_container,
        w && M.popover,
        w && M[a],
        m && M.sheet,
        N && M.fullscreen,
        o
      ),
      style: s,
      ..._,
      children: [
        m && /* @__PURE__ */ n(
          "div",
          {
            className: d(M.backdrop, $ && M.drag),
            style: I,
            onClick: e
          }
        ),
        /* @__PURE__ */ g(
          "div",
          {
            className: d(
              M.content,
              m && M.content_sheet,
              N && M.content_full,
              $ && M.drag
            ),
            style: P,
            onPointerDown: b,
            onPointerMove: v,
            onPointerUp: y,
            children: [
              m && /* @__PURE__ */ n(
                "button",
                {
                  className: M.handle
                }
              ),
              r
            ]
          }
        )
      ]
    }
  );
});
Oe.displayName = "Dropdown";
const it = (t, e, r) => {
  const o = Math.max(1, Math.floor(e)), s = Array.from({
    length: o
  }, () => []), {
    priorityItemId: c,
    getItemId: a
  } = r || {};
  if (!c || !a) {
    for (let _ = 0; _ < t.length; _++) {
      const p = t[_];
      p !== void 0 && s[_ % o]?.push(p);
    }
    return s;
  }
  const u = t.filter((_) => a(_) !== c);
  for (let _ = 0; _ < u.length; _++) {
    const p = u[_];
    p !== void 0 && s[_ % o]?.push(p);
  }
  return s;
}, Ae = "_flex_masonry_1ncng_1", je = "_column_1ncng_8", Be = "_sentinel_1ncng_16", tt = {
  flex_masonry: Ae,
  column: je,
  sentinel: Be
}, Wo = ({
  items: t,
  columns: e,
  getKey: r,
  onEnd: o,
  rootMarginPx: s = 600,
  className: c,
  priorityItemId: a,
  getItemId: u
}) => {
  const _ = Ut(
    () => a && u ? it(
      t,
      e,
      {
        priorityItemId: a,
        getItemId: u
      }
    ) : it(t, e),
    [
      t,
      e,
      a,
      u
    ]
  ), p = C(null), f = C(!1);
  return R(() => {
    if (!o || !p.current) return;
    const l = p.current, i = new IntersectionObserver(
      async (b) => {
        if (b.some((v) => v.isIntersecting) && !f.current) {
          f.current = !0;
          try {
            await o();
          } finally {
            setTimeout(() => f.current = !1, 50);
          }
        }
      },
      {
        rootMargin: `${s}px 0px`
      }
    );
    return i.observe(l), () => i.disconnect();
  }, [
    o,
    s,
    t.length
  ]), /* @__PURE__ */ g(X, { children: [
    /* @__PURE__ */ n("div", { className: d(tt.flex_masonry, c), children: _.map((l, i) => /* @__PURE__ */ n(
      "div",
      {
        className: tt.column,
        children: l.map((b, v) => /* @__PURE__ */ n("div", { children: b }, r ? r(b, v) : v))
      },
      i
    )) }),
    /* @__PURE__ */ n(
      "div",
      {
        ref: p,
        className: tt.sentinel
      }
    )
  ] });
}, De = () => /* @__PURE__ */ n(
  "svg",
  {
    fill: "currentColor",
    height: "16",
    viewBox: "0 0 7 16",
    width: "7",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ n(
      "path",
      {
        d: "M7 8C7 7.28089 6.47063 6.76339 5.94469 6.34477C5.58247 6.05661 4.88475 5.56091 4.42024 5.23091C4.34841 5.17988 4.28216 5.13281 4.22359 5.09109C4.15599 5.04298 4.07923 4.98844 3.99566 4.92905C3.41927 4.5195 2.51874 3.87963 2.06622 3.53209C1.34584 2.97875 0.733718 2.4307 0.383628 1.60164C0.0604677 0.833691 0 0 0 0L0 16C0 16 0.0604677 15.1663 0.383628 14.3984C0.733718 13.5693 1.34584 13.0213 2.06622 12.4679C2.51874 12.1204 3.41928 11.4805 3.99568 11.0709C4.07924 11.0116 4.156 10.957 4.22359 10.9089C4.28216 10.8672 4.34841 10.8201 4.42023 10.7691C4.88474 10.4391 5.58247 9.9434 5.94469 9.65523C6.47063 9.23661 7 8.71911 7 8Z",
        fill: "currentColor"
      }
    )
  }
), Re = "_fullscreen_16rdo_1", Fe = "_simple_16rdo_6", Xe = "_labeled_16rdo_11", We = "_fullscreen_label_16rdo_11", J = {
  fullscreen: Re,
  simple: Fe,
  labeled: Xe,
  fullscreen_label: We
}, Yo = ({
  isFullscreen: t,
  className: e,
  onClick: r,
  showLabel: o = !1
}) => /* @__PURE__ */ g(
  "button",
  {
    className: d(
      J.fullscreen,
      o ? J.labeled : J.simple,
      e
    ),
    onClick: r,
    children: [
      o && /* @__PURE__ */ g("div", { className: J.fullscreen_label, children: [
        t ? "Свернуть экран" : "На весь экран",
        /* @__PURE__ */ n(De, {})
      ] }),
      t ? /* @__PURE__ */ n(At, {}) : /* @__PURE__ */ n(jt, {})
    ]
  }
), Ye = "_wrap_1h5mp_1", Ue = "_full_1h5mp_4", qe = "_loader_1h5mp_11", et = {
  wrap: Ye,
  full: Ue,
  loader: qe
}, He = ({ isFullPage: t }) => /* @__PURE__ */ n("div", { className: d(et.wrap, t && et.full), children: /* @__PURE__ */ g(
  "svg",
  {
    className: et.loader,
    fill: "none",
    height: "80",
    viewBox: "0 0 80 80",
    width: "80",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "28.1379",
          rx: "3.31034",
          width: "6.62069",
          x: "36.6896"
        }
      ),
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "27.9042",
          rx: "3.18905",
          transform: "rotate(45 65.7915 9.69873)",
          width: "6.37811",
          x: "65.7915",
          y: "9.69873"
        }
      ),
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "27.9042",
          rx: "3.18905",
          transform: "rotate(135 70.3018 65.7915)",
          width: "6.37811",
          x: "70.3018",
          y: "65.7915"
        }
      ),
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "28.1379",
          rx: "3.03448",
          transform: "rotate(90 79.7241 36.9653)",
          width: "6.06897",
          x: "79.7241",
          y: "36.9653"
        }
      ),
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "28.1379",
          rx: "3.31034",
          width: "6.62069",
          x: "36.6896",
          y: "51.8623"
        }
      ),
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "27.9042",
          rx: "3.18905",
          transform: "rotate(45 29.4294 46.0605)",
          width: "6.37811",
          x: "29.4294",
          y: "46.0605"
        }
      ),
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "27.9042",
          rx: "3.18905",
          transform: "rotate(135 33.9396 29.4297)",
          width: "6.37811",
          x: "33.9396",
          y: "29.4297"
        }
      ),
      /* @__PURE__ */ n(
        "rect",
        {
          fill: "currentcolor",
          height: "28.1379",
          rx: "3.03448",
          transform: "rotate(90 28.4138 36.9653)",
          width: "6.06897",
          x: "28.4138",
          y: "36.9653"
        }
      )
    ]
  }
) }), Ze = "_photo_modal_15p2p_1", Ge = "_modal_content_15p2p_23", Ve = "_modal_img_15p2p_33", Je = "_loader_wrap_15p2p_40", Qe = "_close_btn_15p2p_47", ze = "_close_icon_15p2p_57", Ke = "_hidden_15p2p_69", B = {
  photo_modal: Ze,
  modal_content: Ge,
  modal_img: Ve,
  loader_wrap: Je,
  close_btn: Qe,
  close_icon: ze,
  hidden: Ke
}, tn = ({
  link: t,
  onClose: e
}) => {
  const [r, o] = O(!0), s = (c) => {
    c.target === c.currentTarget && e();
  };
  return /* @__PURE__ */ g(
    "div",
    {
      className: B.photo_modal,
      onClick: s,
      children: [
        r && /* @__PURE__ */ n("div", { className: B.loader_wrap, children: /* @__PURE__ */ n(He, {}) }),
        /* @__PURE__ */ g("div", { className: d(B.modal_content, r && B.hidden), children: [
          /* @__PURE__ */ n(
            "img",
            {
              alt: "modal-photo",
              className: B.modal_img,
              src: t,
              onError: () => o(!1),
              onLoad: () => o(!1)
            }
          ),
          /* @__PURE__ */ n(
            "button",
            {
              className: B.close_btn,
              onClick: e,
              children: /* @__PURE__ */ n(mt, { className: B.close_icon })
            }
          )
        ] })
      ]
    }
  );
}, en = "_image_1w3tl_1", nn = "_disabled_modal_1w3tl_11", _t = {
  image: en,
  disabled_modal: nn
}, on = ({
  src: t,
  alt: e = "image",
  className: r,
  style: o = {},
  disabledModal: s = !1
}) => {
  const [c, a] = O(!1);
  return /* @__PURE__ */ g(X, { children: [
    /* @__PURE__ */ n(
      "img",
      {
        alt: e,
        className: d(
          _t.image,
          r,
          s && _t.disabled_modal
        ),
        src: t,
        style: o,
        onClick: () => s ? null : a(!0)
      }
    ),
    c && /* @__PURE__ */ n(
      tn,
      {
        link: t,
        onClose: () => a(!1)
      }
    )
  ] });
}, rn = "_loader_path_18d38_1", sn = {
  loader_path: rn
}, cn = ({ size: t = 50, className: e }) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 50 50",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ n(
      "path",
      {
        className: sn.loader_path,
        d: "M6.25 25C6.25 35.3553 14.6447 43.75 25 43.75C35.3553 43.75 43.75 35.3553 43.75 25C43.75 14.6447 35.3553 6.25 25 6.25",
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeWidth: "4.16667"
      }
    )
  }
), an = "_outside_wrap_scg5g_1", ln = "_middle_wrap_scg5g_13", _n = "_float_top_scg5g_21", dn = "_inside_wrap_scg5g_25", un = "_float_bottom_scg5g_29", pn = "_close_btn_scg5g_48", mn = "_close_btn_outside_scg5g_75", hn = "_is_mobile_float_scg5g_85", fn = "_full_screen_scg5g_97", T = {
  outside_wrap: an,
  middle_wrap: ln,
  float_top: _n,
  inside_wrap: dn,
  float_bottom: un,
  close_btn: pn,
  close_btn_outside: mn,
  is_mobile_float: hn,
  full_screen: fn
}, Uo = ({
  Trigger: t,
  isCloseBtnHidden: e,
  onClose: r,
  onOpen: o,
  children: s,
  closeOnBackDropClick: c,
  isOpen: a,
  width: u,
  isFullScreenMobile: _ = !0,
  mobileFloat: p,
  isInsideCloseBtn: f = !0,
  insideWrapClassName: l,
  outsideWrapClassName: i,
  propContainerRef: b
}) => {
  const v = C(null), [y, $] = O(!1);
  yt(a || y);
  const m = () => {
    $(!1), r?.();
  }, N = () => {
    $(!0), o?.();
  }, w = (I) => {
    c && I?.target === v.current && m();
  }, P = t ? gt.map(t, (I) => bt(I) ? vt(I, {
    onClick: N
  }) : I) : /* @__PURE__ */ n(X, {});
  return /* @__PURE__ */ g(X, { children: [
    P,
    (a || y) && /* @__PURE__ */ n(xt, { container: b || document.body, children: /* @__PURE__ */ n(
      "div",
      {
        ref: v,
        className: d(
          T.outside_wrap,
          p && T.is_mobile_float,
          i && i
        ),
        "data-testid": "lms-modal-wrapper",
        onClick: w,
        children: /* @__PURE__ */ n(
          "div",
          {
            className: d(
              T.middle_wrap,
              p && T[p]
            ),
            children: /* @__PURE__ */ g(
              "div",
              {
                className: d(
                  T.inside_wrap,
                  l && l,
                  !p && _ && T.full_screen
                ),
                style: u ? {
                  width: u
                } : void 0,
                children: [
                  !e && /* @__PURE__ */ n(
                    "button",
                    {
                      className: d(T.close_btn, !f && T.close_btn_outside),
                      "data-testid": "lms-modal-close-btn",
                      type: "button",
                      onClick: m,
                      children: /* @__PURE__ */ n(ht, {})
                    }
                  ),
                  typeof s == "function" ? s(m) : s
                ]
              }
            )
          }
        )
      }
    ) })
  ] });
};
var gn = /* @__PURE__ */ ((t) => (t.Top = "float_top", t.Bottom = "float_bottom", t))(gn || {}), bn = /* @__PURE__ */ ((t) => (t.Success = "success", t.Error = "error", t))(bn || {});
const vn = "_play_1qfks_1", wn = "_loader_1qfks_22", dt = {
  play: vn,
  loader: wn
}, qo = ({
  isShowingControls: t,
  onClick: e,
  Icon: r,
  onMouseLeave: o,
  onMouseMove: s,
  playing: c,
  ended: a = !1,
  isLoading: u = !1,
  className: _
}) => u ? /* @__PURE__ */ n("div", { className: d(dt.loader, _), children: /* @__PURE__ */ n(cn, {}) }) : t || !c || a ? /* @__PURE__ */ n(
  "button",
  {
    "aria-label": "Воспроизвести",
    className: d(
      dt.play,
      _
    ),
    onClick: e,
    onMouseLeave: o,
    onMouseMove: s,
    children: /* @__PURE__ */ n(r, {})
  }
) : null;
var z = /* @__PURE__ */ ((t) => (t.html = "html", t.text = "text", t))(z || {}), St = /* @__PURE__ */ ((t) => (t.Big = "big", t.Small = "small", t))(St || {}), ot = /* @__PURE__ */ ((t) => (t.Top = "top", t.Bottom = "bottom", t))(ot || {});
const yn = "_slide_image_52v64_1", xn = "_slide_image_indicator_bottom_52v64_8", Nn = "_cover_52v64_12", kn = "_variant_small_52v64_21", Cn = "_variant_big_52v64_25", $n = "_indicators_52v64_30", Sn = "_indicators_top_52v64_40", In = "_indicators_bottom_52v64_45", Mn = "_indicators_small_52v64_50", Pn = "_indicator_52v64_30", En = "_active_52v64_60", Tn = "_indicators_big_52v64_76", Ln = "_navigations_52v64_102", On = "_nav_button_52v64_113", An = "_icon_52v64_132", jn = "_rotated_52v64_136", k = {
  slide_image: yn,
  slide_image_indicator_bottom: xn,
  cover: Nn,
  variant_small: kn,
  variant_big: Cn,
  indicators: $n,
  indicators_top: Sn,
  indicators_bottom: In,
  indicators_small: Mn,
  indicator: Pn,
  active: En,
  indicators_big: Tn,
  navigations: Ln,
  nav_button: On,
  icon: An,
  rotated: jn
}, Bn = 50, Dn = ({
  images: t,
  variant: e = St.Small,
  width: r,
  height: o,
  initialIndex: s = 0,
  showArrows: c = !1,
  showIndicators: a = !0,
  indicatorsPosition: u = ot.Bottom,
  indicatorsClassName: _,
  className: p
}) => {
  const [f, l] = O(() => Math.max(0, Math.min(t.length - 1, s))), i = C(null), b = C(null), v = C(null), y = C(!1), $ = C(!1), m = C(null), N = wt(768), w = t.length > 1, P = w && !c && !N, I = E(
    (h) => Math.max(0, Math.min(t.length - 1, h)),
    [t.length]
  ), A = E(() => {
    w && l((h) => h === t.length - 1 ? 0 : h + 1);
  }, [w, t.length]), W = E(() => {
    w && l((h) => h === 0 ? t.length - 1 : h - 1);
  }, [w, t.length]), rt = E(
    (h, x) => {
      const j = h - x.left, Y = Math.floor(j / x.width * t.length);
      return I(Y);
    },
    [t.length, I]
  ), It = E(
    (h) => {
      if (!P || h.pointerType !== "mouse" && h.pointerType !== "pen" && h.pointerType !== "touch")
        return;
      const x = h.currentTarget.getBoundingClientRect();
      l(rt(h.clientX, x));
    },
    [P, rt]
  ), Mt = E(
    (h) => {
      if (!w || !N) return;
      const x = h.touches[0];
      x && (b.current = x.clientX, v.current = x.clientY, y.current = !1);
    },
    [w, N]
  ), Pt = E(
    (h) => {
      if (!w || !N || b.current === null) return;
      const x = h.changedTouches[0];
      if (!x) return;
      const j = x.clientX - b.current;
      y.current && Math.abs(j) >= Bn && (j < 0 ? A() : W(), $.current = !0, m.current && clearTimeout(m.current), m.current = setTimeout(() => {
        $.current = !1;
      }, 100)), b.current = null, v.current = null, y.current = !1;
    },
    [
      w,
      N,
      A,
      W
    ]
  ), Et = E((h) => {
    $.current && (h.stopPropagation(), h.preventDefault());
  }, []);
  return R(() => {
    const h = i.current;
    if (!h || !w || !N) return;
    const x = (j) => {
      if (b.current === null || v.current === null) return;
      const Y = j.touches[0];
      if (!Y) return;
      const st = Math.abs(Y.clientX - b.current), Tt = Math.abs(Y.clientY - v.current);
      st > Tt && st > 10 && (y.current = !0, j.preventDefault());
    };
    return h.addEventListener(
      "touchmove",
      x,
      { passive: !1 }
    ), () => {
      h.removeEventListener("touchmove", x);
    };
  }, [w, N]), R(() => () => {
    m.current && clearTimeout(m.current);
  }, []), qt(() => {
    i.current && (i.current.style.setProperty(
      "width",
      `${r}px`,
      "important"
    ), i.current.style.setProperty(
      "height",
      `${o}px`,
      "important"
    ));
  }, [r, o]), t.length ? /* @__PURE__ */ g(
    "div",
    {
      className: d(
        k.slide_image,
        k[`variant_${e}`],
        k[`slide_image_indicator_${u}`],
        p
      ),
      children: [
        /* @__PURE__ */ n(
          "img",
          {
            ref: i,
            alt: `slide-${f + 1}`,
            className: k.cover,
            decoding: "async",
            loading: "eager",
            src: t[f],
            style: {
              width: `${r}px`,
              height: `${o}px`,
              touchAction: w && N ? "pan-y" : void 0
            },
            onClick: Et,
            onPointerMove: P ? It : void 0,
            onTouchEnd: Pt,
            onTouchStart: Mt
          }
        ),
        c && w && /* @__PURE__ */ g("div", { className: k.navigations, children: [
          /* @__PURE__ */ n(
            "button",
            {
              "aria-label": "Предыдущий",
              className: d(k.nav_button, k.prev),
              type: "button",
              onClick: W,
              children: /* @__PURE__ */ n(ct, { className: d(k.icon, k.rotated) })
            }
          ),
          /* @__PURE__ */ n(
            "button",
            {
              "aria-label": "Следующий",
              className: d(k.nav_button, k.next),
              type: "button",
              onClick: A,
              children: /* @__PURE__ */ n(ct, { className: k.icon })
            }
          )
        ] }),
        a && w && /* @__PURE__ */ n(
          "div",
          {
            className: d(
              k.indicators,
              k[`indicators_${u}`],
              k[`indicators_${e}`]
            ),
            children: t.map((h, x) => /* @__PURE__ */ n(
              "button",
              {
                "aria-label": `Перейти к слайду ${x + 1}`,
                className: d(
                  k.indicator,
                  x === f && k.active,
                  _
                ),
                "data-active": String(x === f),
                type: "button",
                onClick: () => l(x)
              },
              x
            ))
          }
        )
      ]
    }
  ) : null;
}, Rn = /* @__PURE__ */ new Set([
  "b",
  "i",
  "u",
  "em",
  "strong",
  "p",
  "br",
  "hr",
  "a",
  "s",
  "ul",
  "ol",
  "li",
  "span",
  "div",
  "img",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
  "code",
  "pre",
  "table",
  "thead",
  "tbody",
  "tr",
  "td",
  "th",
  "ins"
]), ut = {
  a: [
    "href",
    "title",
    "target"
  ],
  img: [
    "src",
    "alt",
    "title"
  ],
  span: ["class"],
  div: ["class"],
  table: [
    "border",
    "cellpadding",
    "cellspacing",
    "style"
  ],
  "*": ["style"]
}, Fn = (t) => t.split(";").reduce((e, r) => {
  const [o, s] = r.split(":");
  if (!o || !s) return e;
  const c = o.trim().replace(/-([a-z])/g, (a, u) => u.toUpperCase());
  return e[c] = s.trim(), e;
}, {}), Xn = (t, e, r, o, s) => e === "class" && o ? ["className", r] : e === "style" && o ? ["style", Fn(r)] : e === "src" && t === "img" && s !== void 0 ? ["src", r.startsWith("http") ? r : s + r] : e !== "style" || o ? [e, r] : null, Wn = (t) => t.replace(/[""«»„]/g, '"').replace(/[''‛‹›]/g, "'"), Yn = (t) => {
  const e = Wn(t).replace(/\s*\+\s*/g, " ");
  if (/\[\s*["'`]/.test(e) && /["'`]\s*\]/.test(e)) {
    const c = e.indexOf("["), a = e.lastIndexOf("]");
    if (c !== -1 && a > c) {
      const u = e.slice(c, a + 1);
      try {
        const _ = JSON.parse(u);
        if (Array.isArray(_))
          return _.map(String).filter((p) => /\.(png|jpe?g|webp|gif|svg)(\?.*)?$/i.test(p));
      } catch {
        console.error("Could not parse text from text");
      }
    }
  }
  const o = [...e.matchAll(/(["'])(\/[^"']+\.(?:png|jpe?g|webp|gif|svg)(?:\?\S*)?)\1/gi)].map((c) => c[2]), s = Array.from(new Set(o));
  return s.length ? s : null;
}, Un = (t) => {
  const e = document.createElement("textarea");
  return e.innerHTML = t, e.value;
}, nt = (t, e = "", r = z.html, o = !1, s, c, a = !1, u = !1) => t.flatMap((_, p) => {
  const f = `${e}-${p}`;
  if (_.nodeType === Node.TEXT_NODE) {
    const l = Un(_.textContent ?? ""), i = Yn(l);
    if (i && i.length) {
      const b = s ? i.map((v) => s + v) : i;
      return G(Dn, {
        key: f,
        images: b,
        height: 384,
        indicatorsPosition: ot.Bottom,
        showArrows: !0
      });
    }
    return l.trim() ? G(
      Ht,
      {
        key: f
      },
      l
    ) : [];
  }
  if (_.nodeType === Node.ELEMENT_NODE) {
    const l = _, i = l.tagName.toLowerCase();
    if (r === z.text)
      return nt(
        Array.from(l.childNodes),
        f,
        r,
        o,
        s,
        c,
        a,
        u
      );
    if (!Rn.has(i)) return [];
    const b = ut[i] ?? [], v = /* @__PURE__ */ new Set([...b, ...ut["*"] || []]), y = {
      key: f
    };
    if (Array.from(l.attributes).forEach((m) => {
      const N = m.name.toLowerCase(), w = m.value;
      if (N.startsWith("on") || /^javascript:/i.test(w) || !v.has(N)) return;
      const P = Xn(
        i,
        N,
        w,
        o,
        s
      );
      if (P) {
        const [I, A] = P;
        y[I] = A;
      }
    }), i === "a" && c && (y[c] = ""), i === "img" && u && y.style) {
      const m = { ...y.style };
      delete m.height, delete m.maxHeight, y.style = m;
    }
    if (i === "img" && a && typeof y.src == "string")
      return G(on, {
        ...y,
        src: y.src,
        disabledModal: !a
      });
    const $ = nt(
      Array.from(l.childNodes),
      f,
      r,
      o,
      s,
      c,
      a,
      u
    );
    return G(
      i,
      y,
      ...$
    );
  }
  return [];
}), qn = "_parsed_wufs7_1", Hn = {
  parsed: qn
}, Ho = ({
  className: t,
  keyPrefix: e,
  mode: r = z.html,
  useStyles: o,
  html: s,
  imgSrcPrefix: c,
  linkDataAttr: a,
  enableImageModal: u = !1,
  ignoreImageHeight: _ = !1
}) => {
  const l = new DOMParser().parseFromString(s, "text/html").body, i = nt(
    Array.from(l.childNodes),
    e,
    r,
    o,
    c,
    a,
    u,
    _
  );
  return /* @__PURE__ */ n("div", { className: d(Hn.parsed, t), children: i });
}, Zn = "_play_pause_11nvb_1", Gn = {
  play_pause: Zn
}, Zo = ({
  Icon: t,
  onClick: e
}) => /* @__PURE__ */ n(
  "button",
  {
    "aria-label": "Воспроизвести",
    className: Gn.play_pause,
    onClick: e,
    children: /* @__PURE__ */ n(t, {})
  }
), Vn = "_progress_bar_i35jg_1", Jn = "_pip_bar_i35jg_12", Qn = "_progress_bar_fill_i35jg_16", zn = "_progress_bar_thumb_i35jg_27", q = {
  progress_bar: Vn,
  pip_bar: Jn,
  progress_bar_fill: Qn,
  progress_bar_thumb: zn
}, Go = ({
  duration: t,
  currentTime: e,
  seekTo: r,
  isPip: o = !1
}) => {
  const s = C(null), c = C(null), a = C(null);
  return Gt({
    rangeRef: s,
    thumbRef: c,
    fillRef: a,
    duration: t,
    currentTime: e,
    seekTo: r
  }), /* @__PURE__ */ g(
    "div",
    {
      ref: s,
      className: d(q.progress_bar, o && q.pip_bar),
      children: [
        /* @__PURE__ */ n(
          "div",
          {
            ref: a,
            className: d(q.progress_bar_fill, o && q.pip_bar)
          }
        ),
        /* @__PURE__ */ n(
          "button",
          {
            ref: c,
            className: q.progress_bar_thumb
          }
        )
      ]
    }
  );
}, Kn = "_wrap_21h4o_1", to = "_line_21h4o_8", pt = {
  wrap: Kn,
  line: to
}, eo = (t) => {
  const e = Number(t);
  return isNaN(e) || !t ? 0 : e >= 0 && e < 1 ? `${e * 100}%` : e >= 100 ? "100%" : `${e}%`;
}, Vo = ({ percent: t }) => {
  const e = eo(t) ?? 0;
  return /* @__PURE__ */ n("div", { className: pt.wrap, children: /* @__PURE__ */ n(
    "div",
    {
      className: pt.line,
      style: {
        width: e
      }
    }
  ) });
}, no = "_radio_hbjtm_1", oo = "_circle_hbjtm_8", ro = "_checked_hbjtm_22", so = "_text_hbjtm_26", co = "_hidden_hbjtm_31", H = {
  radio: no,
  circle: oo,
  checked: ro,
  text: so,
  hidden: co
}, Jo = ({
  label: t,
  checked: e,
  name: r,
  onChange: o,
  classNames: s
}) => /* @__PURE__ */ g("label", { className: d(H.radio, s), children: [
  /* @__PURE__ */ n(
    "input",
    {
      "aria-label": typeof t == "string" ? t : "",
      checked: e,
      className: H.hidden,
      name: r,
      type: "radio",
      onChange: o
    }
  ),
  /* @__PURE__ */ n("div", { className: d(H.circle, e && H.checked) }),
  /* @__PURE__ */ n("div", { className: H.text, children: t })
] }), ao = "_settings_k2xxg_1", lo = {
  settings: ao
}, Qo = ({
  onClick: t,
  triggerRef: e,
  disabled: r
}) => /* @__PURE__ */ n(
  "button",
  {
    ref: e,
    "aria-label": "Настройки",
    className: lo.settings,
    disabled: r,
    onClick: t,
    children: /* @__PURE__ */ n(Bt, {})
  }
), io = "_wrap_1nk4g_1", _o = "_content_1nk4g_13", uo = "_header_1nk4g_24", po = "_title_1nk4g_33", mo = "_close_btn_1nk4g_40", ho = "_close_icon_1nk4g_49", fo = "_main_content_1nk4g_54", go = "_actions_1nk4g_59", L = {
  wrap: io,
  content: _o,
  header: uo,
  title: po,
  close_btn: mo,
  close_icon: ho,
  main_content: fo,
  actions: go
}, zo = ({
  Trigger: t,
  children: e,
  actions: r,
  title: o,
  isCloseBtnHidden: s = !1,
  onClose: c,
  onOpen: a,
  isOpen: u,
  width: _,
  closeOnBackDropClick: p = !0
}) => {
  const f = C(null), [l, i] = O(!1), b = () => {
    i(!0), a?.();
  }, v = E(() => {
    i(!1), c?.();
  }, [c]), y = () => {
    p && v();
  }, $ = t ? gt.map(t, (m) => bt(m) ? vt(m, {
    onClick: b
  }) : m) : /* @__PURE__ */ n(X, {});
  return Zt(
    f,
    f,
    y
  ), yt(!!(l || u)), /* @__PURE__ */ g(X, { children: [
    $,
    (l || u) && /* @__PURE__ */ n(xt, { container: document.body, children: /* @__PURE__ */ n("div", { className: L.wrap, children: /* @__PURE__ */ g(
      "div",
      {
        ref: f,
        className: L.content,
        style: _ ? {
          width: _
        } : void 0,
        children: [
          (o || !s) && /* @__PURE__ */ g("div", { className: L.header, children: [
            o && /* @__PURE__ */ n("div", { className: L.title, children: o }),
            !s && /* @__PURE__ */ n(
              "button",
              {
                className: L.close_btn,
                onClick: v,
                children: /* @__PURE__ */ n(mt, { className: L.close_icon })
              }
            )
          ] }),
          /* @__PURE__ */ n("div", { className: L.main_content, children: typeof e == "function" ? e(v) : e }),
          r && /* @__PURE__ */ n("div", { className: L.actions, children: typeof r == "function" ? r(v) : r })
        ]
      }
    ) }) })
  ] });
};
var D = /* @__PURE__ */ ((t) => (t.Info = "info", t.Notification = "notification", t.Error = "error", t.Success = "success", t))(D || {});
const bo = "_container_1ata7_1", vo = "_info_1ata7_13", wo = "_success_1ata7_17", yo = "_error_1ata7_21", xo = "_notification_1ata7_25", No = "_message_wrapper_1ata7_31", ko = "_message_1ata7_31", Co = "_icon_1ata7_41", $o = "_close_icon_1ata7_54", S = {
  container: bo,
  info: vo,
  success: wo,
  error: yo,
  notification: xo,
  message_wrapper: No,
  message: ko,
  icon: Co,
  close_icon: $o
}, Ko = ({
  message: t,
  type: e = D.Info,
  subText: r,
  onClose: o
}) => {
  R(() => {
    if (o) {
      const c = setTimeout(o, 3e3);
      return () => clearTimeout(c);
    }
  }, [o]);
  const s = {
    [D.Success]: /* @__PURE__ */ n(Rt, { className: d(S.icon, S[e]) }),
    [D.Error]: /* @__PURE__ */ n(Dt, { className: d(S.icon, S[e]) }),
    [D.Info]: /* @__PURE__ */ n(at, { className: d(S.icon, S[e]) }),
    [D.Notification]: /* @__PURE__ */ n(at, { className: d(S.icon, S[e]) })
  };
  return /* @__PURE__ */ g("div", { className: d(S.container, S[e]), children: [
    /* @__PURE__ */ g("div", { className: S.message_wrapper, children: [
      s[e],
      /* @__PURE__ */ n("span", { className: S.message, children: t }),
      e !== D.Notification && /* @__PURE__ */ n("button", { onClick: o, children: /* @__PURE__ */ n(ht, { className: S.close_icon }) })
    ] }),
    r && /* @__PURE__ */ n("p", { children: r })
  ] });
}, So = "_volume_control_pa8bi_1", Io = "_volume_button_pa8bi_10", Mo = "_volume_slider_wrapper_pa8bi_24", Po = "_volume_slider_pa8bi_24", Q = {
  volume_control: So,
  volume_button: Io,
  volume_slider_wrapper: Mo,
  volume_slider: Po
}, Eo = (t, e) => t || e === 0 ? Ft : e < 0.5 ? Xt : Wt, tr = ({
  muted: t,
  volume: e,
  onToggle: r,
  onChange: o,
  className: s
}) => {
  const c = t || e === 0, a = Eo(t, e);
  return /* @__PURE__ */ g("div", { className: d(Q.volume_control, s), children: [
    /* @__PURE__ */ n(
      "button",
      {
        "aria-label": c ? "Включить звук" : "Выключить звук",
        className: Q.volume_button,
        type: "button",
        onClick: r,
        children: /* @__PURE__ */ n(a, {})
      }
    ),
    /* @__PURE__ */ n("div", { className: Q.volume_slider_wrapper, children: /* @__PURE__ */ n(
      "input",
      {
        "aria-label": "Громкость",
        className: Q.volume_slider,
        max: 1,
        min: 0,
        step: 0.01,
        type: "range",
        value: e,
        onChange: o
      }
    ) })
  ] });
};
export {
  Bo as BackButton,
  ie as Button,
  Ct as ButtonSize,
  kt as ButtonVariant,
  Do as Checkbox,
  Ro as CircularProgress,
  Fo as ClientOnly,
  Xo as DownloadFile,
  Oe as Dropdown,
  $t as DropdownPosition,
  Z as DropdownVariant,
  Wo as FlexMasonry,
  Yo as FullscreenButton,
  tn as ImageModal,
  on as ImageModalViewer,
  He as Loader,
  cn as LoaderV2,
  Uo as Modal,
  bn as ModalContentType,
  gn as ModalMobileFloat,
  qo as OverlayPlayPauseButton,
  Ho as ParsedHtmlView,
  Zo as PlayPauseButton,
  Go as PlayerProgressBar,
  Vo as ProgressLine,
  Jo as Radiodot,
  z as SanitizeOptionsMode,
  Qo as SettingsButton,
  zo as Sidebar,
  Dn as SlideCards,
  ot as SlideCardsIndicatorsPosition,
  St as SlideCardsVariant,
  D as SnackBarType,
  Ko as Snackbar,
  tr as VolumeControl
};
